import Modal from 'react-bootstrap/Modal';
import ExcelIcon from '../../../src/assets/svg/metaEdit/excel_meta.svg';
import closeIcon from "../../../src/assets/svg/Assetmanagemant/closeIcon.svg";

export const CsvErrorPopUp = ({ show, csvErrorData, handleClose }) => {
    const exportToCSV = () => {
        const headers = ['Row No.', 'Error Info.'];
        const rows = csvErrorData.map(data => [data?.data?.rowNo, data?.data?.error?.Program]);

        const csvContent = [
            headers.join(','),
            ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "csv_error_log.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Modal show={show} contentClassName="rounded modalmainbody" onHide={handleClose} backdrop="static" >
            <Modal.Header closeButton className='p-0 align-items-start'>
                <Modal.Title className="d-flex flex-column" style={{ color: "#FFFFFF", fontWeight: 500 }}>
                    <span>Scheduling Error Log</span>
                    <span className="text-white-50" style={{fontSize: "14px"}}>File: {csvErrorData?.fileName}</span>
                </Modal.Title>
                    <div onClick={handleClose} style={{ cursor: "pointer" }}>
                        <img src={closeIcon} alt="close" />
                    </div>
            </Modal.Header>

            <div className="right-side-content h-100">
                <div className="background-right-container rounded" style={{ height: "100%" }}>
                    <div className={`bottom-content-right h-100`}>
                        <div className={`ads-table ads-font-size mb-2 rounded`} style={{ minHeight: "98%" }}>
                            <table className={`table`}>
                                <thead>
                                    <tr>
                                        <th>Row No.</th>
                                        <th>Error Info.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        csvErrorData?.data?.map((data) => (
                                            <tr key={data.id}>
                                                <td style={{ width: "20%" }}>{data?.rowNo}</td>
                                                <td style={{ width: "80%" }}>{data?.error?.Program? data?.error?.Program : "Unknown error occurred"}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* <Modal.Footer style={{ padding: "0px" }}> */}
                <div className="d-flex justify-content-between">
                    <button className="btn btn-cancel w-50 p-1 h-100 me-1 text-white" type="button" variant="secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary w-50 p-1 h-100 ms-1" type="button" variant="secondary" onClick={exportToCSV}>
                        <img className="me-1" src={ExcelIcon} width={20} alt="Export" /> Export CSV
                    </button>
                </div>
            {/* </Modal.Footer> */}
        </Modal>
    );
};
